<script lang="ts">
  import { type SanityContext, key } from '$lib/context/sanity';
  import type { PageHero } from '$lib/sanity/schemas';
  import { getContext } from 'svelte';
  import {
    useEncodeDataAttribute,
    type ContentSourceMap,
    type StudioPathLike
  } from '@sanity/svelte-loader';
  import { sanityStudioURL } from '$lib/client';
  import ScreenReaderOnly from '$components/Accessibility/ScreenReaderOnly.svelte';

  interface Props {
    document: PageHero;
    sourceMap: ContentSourceMap;
    path?: StudioPathLike;
  }

  let { document, sourceMap, path = [] }: Props = $props();

  let encodeDataAttribute = $derived(useEncodeDataAttribute(document, sourceMap, sanityStudioURL));

  const { urlBuilder } = getContext<SanityContext>(key);
  let backgroundImg = $derived(
    urlBuilder.image(document.background.image.asset).auto('format').url()
  );
  let headlineSvg = $derived(
    document.headline?.svg && urlBuilder.image(document.headline.svg.asset).auto('format').url()
  );
</script>

<div>
  <!-- TODO: post-POC implement dynamic sizing with srcset and explicit aspect-ratio assignment -->
  <img
    class="background-img"
    src={backgroundImg}
    alt={document.background.altText}
    data-sanity={encodeDataAttribute([...path, 'background', 'image'])}
  />
  {#if document.headline?.svg}
    <h1 data-sanity={encodeDataAttribute([...path, 'headline', 'text'])}>
      <ScreenReaderOnly>
        {document.headline.text}
      </ScreenReaderOnly>
      <img class="headline-svg" src={headlineSvg} alt={document.headline.text} aria-hidden="true" />
    </h1>
  {/if}
</div>

<style lang="scss">
  @import 'src/scss/media';
  @import 'src/scss/variables';

  div {
    position: relative;
    margin: var(--twist-core-spacing-0) auto;

    @include at('max') {
      max-width: $max-width-page - 2 * $max-width-margin;
    }
  }

  .background-img {
    width: 100%;
  }

  .headline-svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>
